// extracted by mini-css-extract-plugin
export default {"title":"t6-z","warning":"u6-z","sizeOptionsLegendText":"v6-z"};